import React from 'react';
import { useActive, useCommands } from '@remirror/react';
import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuList,
  useColorModeValue,
  VStack,
} from '@cardboard-ui/react';
import { useToolbarActive } from '../toolbar/tools/utils';
import { DropdownIcon, H1Icon, H2Icon, H3Icon } from 'components/icons';
import { t } from '@lingui/macro';
import { FloatingToolbarMenuItem } from './FloatingToolbarMenuItem';

export function HeadingTools() {
  const commands = useCommands();
  const active = useActive();
  const { headingDisabled } = useToolbarActive();

  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={
          <Box marginLeft={2}>
            <DropdownIcon />
          </Box>
        }
        isDisabled={headingDisabled}
        size="xs"
        variant="ghost"
        fontWeight="normal"
      >
        {t`Heading`}
      </MenuButton>
      <MenuList
        shadow="lg"
        py="4"
        color={useColorModeValue('gray.600', 'gray.200')}
        px="3"
        minW="auto"
      >
        <VStack align="flex-start">
          <FloatingToolbarMenuItem
            title={t`Heading 1`}
            icon={<H1Icon />}
            onClick={() => commands.toggleHeading({ level: 1 })}
            selected={active.heading({ level: 1 })}
          />
          <FloatingToolbarMenuItem
            title={t`Heading 2`}
            icon={<H2Icon />}
            onClick={() => commands.toggleHeading({ level: 2 })}
            selected={active.heading({ level: 2 })}
          />
          <FloatingToolbarMenuItem
            title={t`Heading 3`}
            icon={<H3Icon />}
            onClick={() => commands.toggleHeading({ level: 3 })}
            selected={active.heading({ level: 3 })}
          />
        </VStack>
      </MenuList>
    </Menu>
  );
}
